import { Link } from 'react-router-dom';



export default function Intro (){
  return (
    <div className='relative flex items-center justify-start w-full  team-background rounded-t-3xl bottom-[22px]'>
        <div className='flex flex-col-reverse items-start justify-end w-full gap-y-10 md:gap-0 md:flex-row '>
        <div className='flex flex-col  justify-center w-[100%] sm:w-[70%] md:w-[53%] px-16 pt-28 pb-32 rounded-t-3xl sm:rounded-l-3xl md:rounded-tr-3xl text-[#303030] bg-[white] items-start gap-y-4 '>
            <h1 className='text-3xl font-extrabold md:text-4xl xl:text-6xl'>Your<br/><span className='relative block bottom-[11px] left-[26px]'>Team?</span></h1>
            <p className=' text-[14px] lg:text-[15px] xl:text-[17px] w-[100%] sm:w-[95%] md:w-[85%] lg:w-[80%]'>We are a group of university friends trying to make a dent in the world. We are skilled and have decided to form a great team together. Each of us specializes in something, and we help and support each other with our freelancing projects. We often collaborate on work to maintain the quality of our projects. Together, we aspire to leave a lasting impact through our combined skills and dedication.</p>
            <Link to={'/my-projects'}>
        <button className=" px-4 text-sm rounded-3xl py-[13px] font-medium transition-all duration-300 text-black bg-[#fdfdfd] border-[1px] border-black ">
       My Projects
        </button>
        </Link>    
        </div>
        
       
        </div>
    </div>
  )
}
